const host = `https://aiconversationalagent.onrender.com`;

export const environment = {
  production: false,
  fronEndUrl: "https://pulsy-frontend-app-dev.onrender.com",
  frontEndIp: "216.24.57.1",
  baseUrl: `${host}`,
  authUrl: `${host}/auth`,
  telephonyUrl: `${host}/phone`,
  registrationUrl: `${host}/registration`,
  autoCallBackSettingsUrl: `${host}/autoCallBackSettings`,
  callBackSettingsUrl: `${host}/callBackSettings`,
  whiteLabel: `${host}/whitelabel`,
  validationUrl: `${host}/validation`,
  userUrl: `${host}/user`,
  telegramUrl: `${host}/telegram`,
  voiceUrl: `${host}/voice`,
  llmChoiceUrl: `${host}/llmChoice`,
  knowledgeUrl: `${host}/knowledge`,
  aiAgentUrl: `${host}/business`,
  serviceUrl: `${host}/service`,
  smsSettingsUrl: `${host}/smsSettings`,
  customDomainUrl : `${host}/customDomain`,
  formUrl: `${host}/form`,
  transferUrl: `${host}/transfer`,
  textMessageUrl: `${host}/textMessage`,
  conversationStepUrl: `${host}/conversationStep`,
  zapUrl: `${host}/zap`,
  makeUrl: `${host}/make`,
  callLogUrl: `${host}/callLog`,
  paymentUrl: `${host}/payment`,
  rebillingUrl: `${host}/rebilling`,
  websocketUrl: `${host}/message`,
  outboundCampaignUrl: `${host}/outbound`,
  notificationIntegrationUrl: `${host}/notificationIntegration`,
  phoneSettingsUrl: `${host}/phoneSettings`,
  googleSheetsIntegrationUrl: `${host}/googleSheet`
};
